import React from 'react';
import { TemplateDropdown } from '../../../components/Attributes/Attributes_old';
import useAsync from '../../../hooks/useAsync';
import { getModuleFieldsBeta } from '../../../api/modules';
import useSettings from '../../../hooks/useSettings';

const ASSET_MODULE_ID = process.env.REACT_APP_MODULE_ID_ASSETS;

const AssetSettings = ({ module, onRefresh }) => {
	const { get: getSetting, set: setSetting } = useSettings();
	const orgDefaultAssetIdentifier = getSetting('defaultAssetId');

	const { value: moduleFields } = useAsync(getModuleFieldsBeta, {
		defaultPayload: { id: ASSET_MODULE_ID },
	});

	const defaultIdentifier = moduleFields?.combined?.find(
		(o) => o?.key === 'serialNumber' && o?.isDefault
	);
	const identifierOptions = moduleFields?.combined?.filter(
		(o) => !o?.isDefault && (o?.type === 'text' || o?.type === 'numeric')
	);

	const identifierCombinedOptions = [
		...(defaultIdentifier
			? [
					{
						label: defaultIdentifier?.label,
						value: defaultIdentifier?.id,
					},
			  ]
			: []),
		...(identifierOptions
			? identifierOptions?.map((option) => ({
					label: option?.label,
					value: option?.id,
			  }))
			: []),
	];

	const selectedIdentifierOption = identifierCombinedOptions?.find(
		(o) => o?.id === orgDefaultAssetIdentifier
	) || {
		label: defaultIdentifier?.label,
		value: defaultIdentifier?.id,
	};
	return (
		<>
			<div className="max-w-3xl mb-4">
				<div className="relative flex flex-col py-4 gap-y-6">
					<div className="flex flex-1 gap-x-8">
						<div className="min-w-0 flex-1 text-sm leading-6">
							<label className="select-none text-xs text-gray-900">
								Asset Identifier
							</label>
							<p className="text-xs text-gray-500 mt-3">
								By default, assets are generally identified by the serial
								number. However, if you generally prefer to use an asset tag or
								custom field, you can select it here
							</p>
						</div>
						<div className="ml-3 flex h-6 items-center">
							<TemplateDropdown
								className={'w-72'}
								options={identifierCombinedOptions}
								value={orgDefaultAssetIdentifier || defaultIdentifier?.id}
								onChange={(index, value, raw) => {
									setSetting('company', 'defaultAssetId', raw?.value, {
										showNotification: { success: 'Setting saved' },
									});
								}}
							/>
						</div>
					</div>
					<div className="flex flex-1 gap-x-8">
						<div className="min-w-0 flex-1 text-sm leading-6">
							<label className="select-none text-xs text-gray-900">
								Default Next PM Field
							</label>
							<p className="text-xs text-gray-500 mt-3">
								Select which event category corresponds with the 'Next PM' asset
								field
							</p>
						</div>
						<div className="ml-3 flex h-6 items-center">
							<TemplateDropdown
								className={'w-72'}
								options={[]}
								value={''}
								onChange={(index, value, raw) => {
									if (value) {
										setSetting('user', 'userLandingPage', raw, {
											showNotification: false,
										});
									} else {
										setSetting('user', 'userLandingPage', null, {
											showNotification: false,
										});
									}
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default AssetSettings;
